import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';

import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

import {
    Filtration, FilterPagingCriteria, FilterSearchCriteria, Operator,
    RelationalLogicalOperator, DescriptiveResponse, FilteredCollection,
    IErrorHandlerToken, IErrorHandler
} from '../../dataModels/';
import { isInputIncluded, getOperator, getRelationalOperator, getIndex } from './filtered-list-parts';


const DATA_REL = "data-rel";
const DATA_IGNORE = "data-ignore";
const DATA_INDEX = "data-index";
const DATA_OPERATOR = "data-operator";


@Component({
    moduleId: module.id,
    selector: 'filtered-list',
    templateUrl: './filtered-list.component.html'
})
export class FilteredListComponent implements OnInit, AfterViewInit {
    @ViewChild(InfiniteScrollDirective) inf: InfiniteScrollDirective;

    searchText: string = '';
    isEmpty: boolean = false;

    @Input() searchKeys: string = '';
    @Input() className: string = '';
    @Input() filtration: Filtration;
    @Input() showSearch: boolean = true;
    @Input() loadDataOnPageLoad: boolean = true;
    @Input() noDataFound: boolean = false;
    @Input() pageSize: number = 10;

    @Input() itemsArray: any[];
    @Input() api: string;
    /*  
        - Tthis function will be executed immediately before sending the request to the database
        - It will take on parameter which is the filtration Criteria Object that is sent to the database
    */
    @Input() beforeSearch: Function;
    @Input() searchMode: string = 'wide';


    @Output('reset') onReset: EventEmitter<any> = new EventEmitter<any>();
    @Output('empty') onEmpty: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output('filter') onFilter: EventEmitter<Filtration> = new EventEmitter<Filtration>();
    @Output('error') onError: EventEmitter<any> = new EventEmitter<any>();
    @Output('data') onData: EventEmitter<FilteredCollection<any>> = new EventEmitter<FilteredCollection<any>>();
    @Output('totalCount') onTotalCount: EventEmitter<number> = new EventEmitter<number>();

    private totalCount: number = -1;
    private scrollTarget: any;
    private internalApi: boolean = false;

    constructor(private elRef: ElementRef, private http: Http, @Inject(IErrorHandlerToken) private handler: IErrorHandler) { }

    ngOnInit() {
        this.pageSize = this.pageSize || 10;

        this.filtration = this.filtration || new Filtration();
        this.filtration.PageCriteria.PageSize = this.pageSize;

        if (this.showSearch && !this.searchKeys) {
            throw new Error("Can't have empty searckKeys when showSearch = true");
        }

        this.scrollTarget = this.elRef.nativeElement.querySelector(".scroll-target");
        if (this.scrollTarget) {
            this.inf.infiniteScrollContainer = this.scrollTarget;
        }

        if (typeof this.beforeSearch !== 'function') {
            this.beforeSearch = function () { };
        }
    }

    ngAfterViewInit() {

        let forms = this.elRef.nativeElement.querySelectorAll("filter-part form") || [];

        for (let form of forms) {
            let submitButtons = form.querySelectorAll("input[type='submit'], button[type='submit']") || [];
            [].forEach.call(submitButtons, submit => {
                submit.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.resetFiltration(form);
                });
            });
        }

        this.internalApi = typeof this.api == 'string' && this.api.length > 4 && Array.isArray(this.itemsArray);

        if (this.internalApi && this.loadDataOnPageLoad) {
            this.resetObjects();
            this.loadData();
        }
    }

    search() {
        this.resetObjects();

        if (this.searchText) {
            this.getKeysArray(this.searchKeys)
                .forEach(x => {
                    this.filtration.SearchCriteria.push(new FilterSearchCriteria(x, Operator.Contains, this.searchText, RelationalLogicalOperator.Or));
                });
        }

        this.emitFilter(this.filtration);
    }

    getKeysArray(key: string): any[] {
        if (typeof key !== 'string') {
            key = '';
        }

        return key.split('|').map(x => x.trim());
    }

    handleOnScrollDown() {
        this.filtration.PageCriteria.PageNumber++;
        this.emitFilter(this.filtration);
    }

    scrollToTop() {

    }

    refresh(formName: string) {
        let form = this.elRef.nativeElement.querySelector(`form[name='${formName}']`);

        if (!form) {
            console.warn("Couldn't find the form with name = " + formName);
        }
setTimeout(() => {
    this.resetFiltration(form);
    
}, 0);
    }

    private resetFiltration(form: any) {
        let validity = this.getFormValidity(form);

        if (!validity) {
            this.emitError({ error: 'form is invalid', errorElement: form });
            return;
        }

        this.resetObjects();

        let search = this.addFormInputs(form);

        search.sort((a, b) => a.index - b.index);

        this.filtration.SearchCriteria.length = 0;
        [].push.apply(this.filtration.SearchCriteria, search.map(item => item.searchCriteria));

        this.emitFilter(this.filtration);
    }

    private resetObjects() {
        this.filtration.PageCriteria = new FilterPagingCriteria();
        this.filtration.PageCriteria.PageSize = this.pageSize;
        this.filtration.SearchCriteria = [];

        this.emitReset();
        if (this.internalApi) {
            this.itemsArray.length = 0;
        }
    }

    //#region Internal Manipulation of List Items
    private loadData() {

        this.beforeSearch(this.filtration);

        this.http.post(this.api, this.filtration)
            .map(res => res.json())
            .subscribe((res: DescriptiveResponse<FilteredCollection<any>>) => {
                if (!res || !res.Value || res.ErrorDescription) {
                    this.handler.Handle(res.ErrorDescription);
                    return;
                }

                this.addDataToItemsArray(res.Value);
            }, err => this.handler.Handle(err));
    }

    private addDataToItemsArray(collection: FilteredCollection<any>) {
        if (!collection) return;

        this.isEmpty = collection.TotalCount < 1;
        this.emitEmpty(this.isEmpty);

        if (collection.TotalCount != this.totalCount) {
            this.totalCount = collection.TotalCount;
            this.emitTotalCount(this.totalCount);
        }

        [].push.apply(this.itemsArray, collection.Collection);
        this.emitData(collection);
    }
    //#endregion

    //#region Dealing with HTML Form

    private addFormInputs(form: any): { index: number, searchCriteria: FilterSearchCriteria }[] {
        /* 
         * process the input tags with all its types e.g. 
         *           <input type='.....' name='.....' />
         */

        /* 
         *      the select tags e.g. 
         *           <select name='.....' > 
         *               <option value='......'> ..... </option 
         *               <option value='......'> ..... </option>
         *           </select>
         */

        let searchCriteria: { index: number, searchCriteria: FilterSearchCriteria }[] = [];

        let inputTags = form.querySelectorAll('input, select') || [];
        for (let input of [].filter.call(inputTags, isInputIncluded)) {

            let opAttr = getOperator(input);
            let relAttr = getRelationalOperator(input);
            let index = getIndex(input);

            this.getKeysArray(input.name)
                .forEach(name => {

                    let searchCriterion = {
                        index: index,
                        searchCriteria: new FilterSearchCriteria(name, opAttr, input.value, relAttr)
                    };

                    searchCriteria.push(searchCriterion);
                });
        }

        return searchCriteria;
    }

    private getFormValidity(form) {
        return form && form.checkValidity && form.checkValidity();
    }
    //#endregion

    //#region Emitter Helpers
    private emitError(error: any) { this.onError.emit(error); }

    private emitFilter(searchFilter: Filtration) {
        if (this.internalApi) {
            this.loadData();
        }

        this.onFilter.emit(searchFilter);
    }

    private emitReset() { this.onReset.emit(); }

    private emitData(data: FilteredCollection<any>) { this.onData.emit(data); }

    private emitTotalCount(count: number) { this.onTotalCount.emit(count); }

    private emitEmpty(state: boolean) { this.onEmpty.emit(state); }
    //#endregion
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/filteredList/filtered-list.component.ts